module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAMAAACg0N8BAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIgDjIAAADTWXzYAAAAD3RSTlMA564Gl7QKAZW+iMcPfsi93dQsAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+cKFBIMFYyUhQoAAAAtSURBVAjXY2BkYmYAAhZ+VjYgxc7BzwmiGbj4uXlANC8/H4ICC0KVQDVAtAMALqMBVwmMLAcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hoime_icon/breadcrumb_right.png
// module id = IpsZ
// module chunks = 44